/**
 * defaultLandingTemplate.ts — Modelo inicial da página pública (landing page)
 *
 * Usado ao criar um modelo do tipo "Página pública". Traz uma estrutura pronta
 * (capa, destaques, depoimentos e formulário) e a definição do formulário
 * padrão de captura de contato nas configurações do documento.
 *
 * RELEASE: v1.0.0 - 2026-09-10 - Versão inicial (Studio, Landing Pages, Fase 1)
 */

import { STUDIO_SCHEMA_VERSION, type StudioDocument } from '@/lib/studio/core';
import {
  DEFAULT_LEAD_FORM,
  type StudioPageDocumentSettings,
} from '@/lib/studio/core/blocks/page';

/** Configurações padrão da página (separadas do tema visual). */
const CONFIGURACOES_PADRAO: StudioPageDocumentSettings = {
  page: {
    maxWidth: '1120px',
    language: 'pt-BR',
  },
  forms: {
    [DEFAULT_LEAD_FORM.id]: DEFAULT_LEAD_FORM,
  },
};

/** Documento inicial de uma página pública. */
export const DEFAULT_LANDING_DOCUMENT: StudioDocument = {
  schemaVersion: STUDIO_SCHEMA_VERSION,
  theme: {
    maxWidth: '1120px',
  },
  settings: CONFIGURACOES_PADRAO as Record<string, unknown>,
  blocks: [
    {
      id: 'hero',
      type: 'page.hero',
      props: {
        title: 'Sua oferta em uma frase clara',
        subtitle: 'Explique em uma linha o benefício principal para quem chegou aqui.',
        ctaLabel: 'Quero saber mais',
        ctaHref: '#formulario',
        align: 'center',
      },
    },
    {
      id: 'features',
      type: 'page.features',
      props: {
        title: 'Por que escolher',
        columns: '3',
        items: [
          'Atendimento rápido|Resposta em até 1 hora útil',
          'Time especializado|Profissionais dedicados ao seu segmento',
          'Sem burocracia|Contratação simples e transparente',
        ].join('\n'),
      },
    },
    {
      id: 'testimonials',
      type: 'page.testimonials',
      props: {
        title: 'O que dizem sobre nós',
        items: [
          'Atendimento impecável do início ao fim.|Maria Souza|Transportes Souza',
          'Resolveram em um dia o que levava semanas.|Carlos Lima|Lima Logística',
        ].join('\n'),
      },
    },
    {
      id: 'form',
      type: 'page.form',
      props: {
        formId: DEFAULT_LEAD_FORM.id,
        title: 'Fale com a gente',
        description: 'Preencha os dados e entraremos em contato.',
        submitLabel: 'Enviar',
        successType: 'message',
        successTitle: 'Obrigado!',
        successMessage: 'Recebemos seus dados. Em breve entraremos em contato.',
      },
    },
  ],
};
